import React from 'react'
import { Flex } from '@chakra-ui/react'

export const ListGroupItemPlaceholder = React.forwardRef((props, ref) => (
  <Flex {...props} ref={ref} borderWidth='1px' align='stretch' justify='center' />
))

export default ListGroupItemPlaceholder
